import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { mediaPc } from '../../../lib/MediaQuery'
import { ReactComponent as ArrowIcon } from '../../../assets/images/icon/arrow-green.svg'

const Wrapper = styled.div`
  display: block;
  width: 92.27vw;
  margin: 5.87vw auto 0;
  padding: 5.33vw 4vw;
  border-radius: 2.13vw;
  background-color: ${(props): string => props.theme.backgroundColors.primary};
  color: ${(props): string => props.theme.textColors.black};

  &:hover {
    opacity: 0.8;
  }

  .badge {
    display: inline-block;
    margin: 0 0 2.4vw;
    padding: 1vw 3vw;
    border-radius: 999px;
    background-color: ${(props): string => props.theme.backgroundColors.bodyBg};
    color: ${(props): string => props.theme.textColors.black};
    font-weight: 700;
    font-size: 2.93vw;
  }

  .title {
    font-size: 3.73vw;
    font-weight: 700;
    letter-spacing: 0.05em;
    margin: 0 0 1.6vw;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      font-size: 3.2vw;
      letter-spacing: 0.05em;
    }

    .arrow-icon {
      width: 1.6vw;
      path {
        fill: ${(props): string => props.theme.textColors.black};
      }
    }
  }

  ${mediaPc`
    width: 675px;
    margin: 20px auto 0;
    padding: 24px 29px;
    border-radius: 18px;

    .badge {
      margin: 0 0 12px;
      padding: 4px 16px;
      font-size: 13px;
    }

    .title {
      font-size: 20px;
      margin: 0 0 8px;
    }

    .row {
      p {
        font-size: 14px;
      }

      .arrow-icon {
        width: 13px;
      }
    }
  `}
`

export const HomeCreatorRecruitmentBanner: React.FC = () => {
  return (
    <Link to="/lp/creator-recruitment">
      <Wrapper>
        <p className="badge">累計クリエイター登録1,000人突破</p>
        <p className="title">あなたも"推される"クリエイターに</p>
        <div className="row">
          <p>登録の流れ・還元率はこちら</p>
          <ArrowIcon className="arrow-icon" />
        </div>
      </Wrapper>
    </Link>
  )
}
